"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalNames = exports.Modal = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const constants_1 = require("./constants");
Object.defineProperty(exports, "ModalNames", { enumerable: true, get: function () { return constants_1.ModalNames; } });
const event_manager_1 = __importDefault(require("./event-manager"));
const modal_events_1 = __importDefault(require("./modal-events"));
class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.closeModal = () => {
            modal_events_1.default.remove();
        };
        this.setContent = (content) => {
            this.setState({ content });
        };
        this.setModal = (currentType) => {
            this.setState({ currentType });
        };
        this.getModalComponent = () => {
            const { currentType } = this.state;
            const { modals } = this.props;
            let modalNode = null;
            if (currentType && modals[currentType]) {
                modalNode = modals[currentType];
            }
            return modalNode;
        };
        this.state = {
            currentType: props.type,
            content: null,
        };
    }
    componentDidMount() {
        const { currentType } = this.state;
        event_manager_1.default
            .register(constants_1.ModalActions.RENDER_MODAL, (type) => this.setModal(type))
            .register(constants_1.ModalActions.REMOVE_MODAL, () => this.removeModal())
            .register(constants_1.ModalActions.SET_CONTENT, (content) => this.setContent(content))
            .emit(constants_1.ModalActions.DID_MOUNT);
        if (currentType) {
            event_manager_1.default.emit(constants_1.ModalActions.RENDER_MODAL, currentType);
        }
    }
    componentDidUpdate(_prevProps, prevState) {
        const { currentType } = this.state;
        if (currentType && prevState.currentType !== currentType)
            event_manager_1.default.emit(constants_1.ModalActions.RENDER_MODAL, currentType);
    }
    componentWillUnmount() {
        event_manager_1.default.clear(constants_1.ModalActions.RENDER_MODAL).emit(constants_1.ModalActions.WILL_UNMOUNT);
    }
    removeModal() {
        const { history } = this.props;
        const searchObj = (0, carabiners_1.createSearchObject)(history.location.search);
        delete searchObj.modal;
        history.push({
            pathname: history.location.pathname,
            search: (0, carabiners_1.createSearchString)(searchObj),
        });
        this.setState({
            currentType: null,
        });
    }
    render() {
        const ModalNode = this.getModalComponent();
        const { content } = this.state;
        if (ModalNode) {
            // @ts-ignore
            return React.createElement(ModalNode, { content: content });
        }
        return null;
    }
}
exports.Modal = Modal;
Modal.defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    type: null,
};
exports.default = (0, react_router_1.withRouter)(Modal);
